import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Tooltip,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';
import {
  Visibility as ViewIcon,
  CheckCircle as ApproveIcon
} from '@mui/icons-material';
import { format } from 'date-fns';

const TransferHistoryTable = ({ transfers, loading, onView, onApprove, onRefresh }) => {
  const getStatusColor = (status) => {
    const colors = {
      pending: 'warning',
      completed: 'success',
      rejected: 'error',
      cancelled: 'default'
    };
    return colors[status] || 'default';
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return format(new Date(date), 'MMM dd, yyyy');
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (transfers.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          No transfers found
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Transfer #</TableCell>
            <TableCell>Material</TableCell>
            <TableCell>Quantity</TableCell>
            <TableCell>From Site</TableCell>
            <TableCell>To Site</TableCell>
            <TableCell>Requested By</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Reviewed By</TableCell>
            <TableCell>Reviewed At</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transfers.map((transfer) => (
            <TableRow key={transfer.id} hover>
              <TableCell>
                <Typography variant="body2" fontWeight="bold">
                  {transfer.transferNumber}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{transfer.materialName}</Typography>
              </TableCell>
              <TableCell>
                {transfer.quantity} {transfer.unit}
              </TableCell>
              <TableCell>
                <Typography variant="body2">{transfer.fromSite?.siteName}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{transfer.toSite?.siteName}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{transfer.requester?.name}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">{formatDate(transfer.requestedAt)}</Typography>
              </TableCell>
              <TableCell>
                <Chip
                  label={transfer.status.toUpperCase()}
                  color={getStatusColor(transfer.status)}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {transfer.reviewer?.name || '-'}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2">
                  {transfer.reviewedAt ? formatDate(transfer.reviewedAt) : '-'}
                </Typography>
              </TableCell>
              <TableCell align="right">
                <Tooltip title="View Details">
                  <IconButton size="small" onClick={() => onView(transfer)}>
                    <ViewIcon />
                  </IconButton>
                </Tooltip>
                {onApprove && transfer.status === 'pending' && (
                  <Tooltip title="Approve/Reject">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => onApprove(transfer)}
                    >
                      <ApproveIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransferHistoryTable;